import { render, staticRenderFns } from "./SidebarDialog.vue?vue&type=template&id=498fe62a&scoped=true&"
import script from "./SidebarDialog.vue?vue&type=script&lang=ts&"
export * from "./SidebarDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarDialog.vue?vue&type=style&index=0&id=498fe62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fe62a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VSlideXReverseTransition})
